module.exports = new __parcel__URL__("no-restriction-pencil-darkmode.8edb9c79.svg").toString();